/* global window */
/* global google */

import React from 'react';
import PropTypes from 'prop-types';

class GoogleMap extends React.Component {
  constructor(props) {
    super(props);

    this.initialized = false;
  }

  componentDidMount() {
    if (!this.initialized && window.isMapReady) {
      // initialize
      this.map = new google.maps.Map(this.mapNode, {
        center: this.props.center,
        zoom: 16,
      });

      // add markers
      this.markers = this.props.markers.map((m) => {
        return new google.maps.Marker({
          position: m,
          map: this.map,
        });
      });
      this.initialized = true;
    }
  }

  componentWillReceiveProps(nextProps) {
    this.markers.forEach(m => m.setMap(null));
    this.markers = nextProps.markers.map((m) => {
      return new google.maps.Marker({
        position: m,
        map: this.map,
      });
    });
    this.map.setCenter(nextProps.center);
  }

  render() {
    return (
      <div
        className="googleMap"
        ref={(node) => { this.mapNode = node; }}
      />
    );
  }
}

GoogleMap.propTypes = {
  center: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  markers: PropTypes.arrayOf(PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  })),
};

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/google-map.js